import { ApiBase } from './apiBase';
import { METHOD } from '../constant/api';

export class ApiTeams extends ApiBase {
  private static baseUrl: string = '/terms';

  static async get(): Promise<any> {
    const url = this.baseUrl;

    const data = {};
    const config = {
      headers: { Authorization: this.token },
      params: { lang: 'ja' },
    };

    return await this.sendRequest(METHOD.GET, url, data, config)
      .then((value) => {
        return value;
      })
      .catch((error) => {
        throw error;
      });
  }
}
